(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["artical-page-controls"] && !Shopify.designMode) return;
  try {
    
window.addEventListener("load", function () {
  const hash = window.location.hash;

  if (!hash) return;

  const target = document.querySelector(hash);

  if (!target) return;

  const headerEl = document.querySelector('sticky-header');
  const headerHeight = headerEl ? headerEl.offsetHeight : 0;
  const notifHeight = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--notification-bar-height')) || 0;
  const headerOffset = headerHeight + notifHeight;
  const elementPosition = target.getBoundingClientRect().top + window.pageYOffset;
  const offsetPosition = elementPosition - headerOffset;

  window.scrollTo({
    top: offsetPosition,
    behavior: "smooth"
  });
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
class StickyHeader extends HTMLElement {
  constructor() {
    super();

    this.onScrollHandler = this.onScroll.bind(this);
    this.setHeaderHeight = this.setHeaderHeight.bind(this);
  }

  connectedCallback() {
    this.header = document.querySelector('.section-header');
    if (!this.header) return;

    this.headerIsAlwaysSticky =
      this.getAttribute('data-sticky-type') === 'always' ||
      this.getAttribute('data-sticky-type') === 'reduce-logo-size';

    this.currentScrollTop = 0;
    this.preventReveal = false;
    this.headerHeight = this.header.offsetHeight;

    this.predictiveSearch = this.querySelector('predictive-search');

    // Set initial height
    this.setHeaderHeight();

    // Events
    window.addEventListener('scroll', this.onScrollHandler, { passive: true });
    window.addEventListener('resize', this.setHeaderHeight);
    window.addEventListener('load', this.setHeaderHeight);

    window
      .matchMedia('(max-width: 990px)')
      .addEventListener('change', this.setHeaderHeight);

    this.hideHeaderOnScrollUp = () => (this.preventReveal = true);
    this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);

    if (this.headerIsAlwaysSticky) {
      this.header.classList.add('shopify-section-header-sticky');
    }

    // Shopify theme editor support
    if (window.Shopify && Shopify.designMode) {
      const observer = new MutationObserver(() => {
        this.setHeaderHeight();
      });

      observer.observe(this.header, {
        attributes: true,
        childList: true,
        subtree: true
      });
    }
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this.onScrollHandler);
    window.removeEventListener('resize', this.setHeaderHeight);
    window.removeEventListener('load', this.setHeaderHeight);
    this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
  }

  setHeaderHeight() {
    requestAnimationFrame(() => {
      this.headerHeight = this.header.offsetHeight;
      document.documentElement.style.setProperty(
        '--header-height',
        `${this.headerHeight}px`
      );
    });
  }

  onScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

    if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

    // Scroll down → hide
    if (scrollTop > this.currentScrollTop && scrollTop > this.headerHeight) {
      this.header.classList.add('scrolled-past-header');
      this.hide();
    }

    // Scroll up → reveal
    else if (scrollTop < this.currentScrollTop && scrollTop > this.headerHeight) {
      this.header.classList.add('scrolled-past-header');

      if (!this.preventReveal) {
        this.reveal();
      } else {
        clearTimeout(this.isScrolling);
        this.isScrolling = setTimeout(() => {
          this.preventReveal = false;
        }, 66);

        this.hide();
      }
    }

    // Back to top → reset
    else if (scrollTop <= this.headerHeight) {
      this.header.classList.remove('scrolled-past-header');
      this.reset();
    }

    this.currentScrollTop = scrollTop;
  }

  hide() {
    if (this.headerIsAlwaysSticky) return;

    this.header.classList.add(
      'shopify-section-header-hidden',
      'shopify-section-header-sticky'
    );

    this.closeMenuDisclosure();
    this.closeSearchModal();
  }

  reveal() {
    if (this.headerIsAlwaysSticky) return;

    this.header.classList.add('shopify-section-header-sticky', 'animate');
    this.header.classList.remove('shopify-section-header-hidden');
  }

  reset() {
    if (this.headerIsAlwaysSticky) return;

    this.header.classList.remove(
      'shopify-section-header-hidden',
      'shopify-section-header-sticky',
      'animate'
    );
  }

  closeMenuDisclosure() {
    this.disclosures =
      this.disclosures || this.header.querySelectorAll('header-menu');

    this.disclosures.forEach(disclosure => disclosure.close());
  }

  closeSearchModal() {
    this.searchModal =
      this.searchModal || this.header.querySelector('details-modal');

    if (this.searchModal) {
      this.searchModal.close(false);
    }
  }
}

customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
